import moment from 'moment'

export const isoDateString = (value) => value.format('YYYY-MM-DD')

export const numberOfDaysUntil = (date) =>
  Math.max(0, moment(date).startOf('day').diff(moment().startOf('day'), 'days'))

export const shortTimeString = (value) => {
  const time = moment(value, 'HH:mm')
  if (time.minutes() === 0) {
    return time.format('ha')
  }
  return time.format('h:mma')
}

export const shortTimeRangeString = (start, end) =>
  `${shortTimeString(start)} – ${shortTimeString(end)}`
